import React from 'react';
import {Avatar} from 'antd';

export function ModelIcon({type}) {
    const style = {background: '#555', color: 'darkorange'};
    switch (type) {
        case 'object':
            return <Avatar style={style}>O</Avatar>;
        case 'array':
            return <Avatar style={style}>A</Avatar>;
        case 'string':
            return <Avatar style={style}>S</Avatar>;
        case 'number':
            return <Avatar style={style}>N</Avatar>;
        case 'integer':
            return <Avatar style={style}>I</Avatar>;
        case 'date':
            return <Avatar style={style}>D</Avatar>;
        case 'bool':
        case 'boolean':
            return <Avatar style={style}>B</Avatar>;
        default:
            return <Avatar style={style}>?</Avatar>;
    }
}
